import { MapPin, MessageCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const MapSection = () => {
  const whatsappUrl =
    'https://wa.me/5511963087549?text=Quero%20saber%20mais%20sobre%20o%20SuperFut%20Kids'

  return (
    <section id="map" className="py-20 bg-slate-50">
      <div className="container px-4 md:px-6 mx-auto">
        <div className="grid gap-12 lg:grid-cols-2 items-center">
          {/* Map Column: Prioritized at the top */}
          <div className="w-full h-[350px] md:h-[450px] lg:h-[500px] rounded-3xl overflow-hidden shadow-xl relative bg-slate-200 animate-fade-in">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58501.71639977049!2d-46.690794999999994!3d-23.59151645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8d157f9d72220221%3A0xcb106d7d519d73c9!2sSuperFut%20Kids!5e0!3m2!1sen!2sbr!4v1770403383273!5m2!1sen!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              className="absolute inset-0 w-full h-full"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de Atendimento SuperFut Kids"
            ></iframe>
          </div>

          {/* Text Column: Content and descriptions */}
          <div className="space-y-8 animate-fade-in-up">
            <div>
              <h2 className="text-3xl md:text-4xl font-display font-bold text-super-text mb-4">
                Área de Atendimento
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed">
                Fazemos seu filho amar o esporte desde cedo e vamos até a sua
                casa! Nossas aulas podem ser realizadas em prédios, condomínios,
                parques e praças. O que for melhor para a sua família.
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex items-start gap-4 transition-transform hover:scale-[1.02] duration-300">
              <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
                <MapPin className="w-6 h-6 text-super-blue" />
              </div>
              <div>
                <h3 className="font-bold text-super-text text-lg mb-2">
                  Regiões Atendidas
                </h3>
                <p className="text-slate-600 leading-relaxed font-medium">
                  Moema, Vila Olímpia, Itaim Bibi, Pinheiros, Alto de Pinheiros
                  e arredores.
                </p>
              </div>
            </div>

            <div>
              <Button
                size="lg"
                className="bg-super-green hover:bg-green-600 text-white font-bold text-lg px-8 rounded-full shadow-lg transition-transform hover:scale-105 w-full sm:w-auto"
                asChild
              >
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Falar no WhatsApp
                </a>
              </Button>
              <p className="text-sm text-slate-500 mt-3 ml-2">
                Clique para agendar sua aula experimental
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
